function _(n,t,r){var a=n(17),o=Math.max;t.exports=function(n){return o(0,a(n))}}
//# sourceMappingURL=to-pos-integer.min.js.map